export function lastFour (ssn: string): string {

    const ssnTrimmed = ssn.trim();
    const ssnLength = ssnTrimmed ? ssnTrimmed.length : 0;

    if (ssnLength === 9) {
      return `***-**-${ssnTrimmed.substring(5, ssnLength)}`;
    }

    return `***-**-${ssnTrimmed.substring(7, ssnLength)}`;
}